<header class="topbar">
  <div class="topbar-inner">
    <a routerLink="/" class="brand" aria-label="Memory home">
      <img src="favicon.svg?v=2" alt="" width="30" height="30">
      <span>Memory</span>
    </a>

    <nav class="desktop-nav" *ngIf="login" aria-label="Main">
      <a *ngFor="let item of navItems"
         [routerLink]="item.route"
         routerLinkActive="active"
         [routerLinkActiveOptions]="{exact: item.exact}">
        <i class="bi" [ngClass]="item.icon"></i>{{ item.label }}
      </a>
    </nav>

    <div class="topbar-actions">
      <ng-container *ngIf="login">
        <button type="button" class="icon-button" *ngIf="pushState !== 'unsupported'"
                (click)="onTogglePush()"
                [disabled]="pushBusy || pushState === 'blocked'"
                [class.on]="pushState === 'on'"
                [attr.aria-pressed]="pushState === 'on'"
                [title]="pushTitle"
                [attr.aria-label]="pushTitle">
          <i class="bi" [ngClass]="pushState === 'on' ? 'bi-bell-fill' : 'bi-bell-slash'"></i>
        </button>
        <button type="button" class="icon-button" (click)="onLogOut()" title="Log out" aria-label="Log out">
          <i class="bi bi-box-arrow-right"></i>
        </button>
      </ng-container>
      <button type="button" class="btn btn-brand btn-sm" *ngIf="!login" (click)="onLogin()">
        <i class="bi bi-box-arrow-in-right"></i>Login
      </button>
    </div>
  </div>
</header>
